import http from "../../../libs/http";
import { api } from '../../../pages/utils'
import moment from 'moment'
http.setMockRule(false, mock => {
  mock.onPost(api.operation.checkLink).reply(() => {
    return [200, {
      code: 0,
      data: {
        // originalCoverUrl: 'https://pic.36krcnd.com/201905/08094859/3aqoslvw6crfijxe!heading',
        // widgetType: '文章、资讯',
      coverPath: "/20190515/v2_1557897790237_img_png",
      coverUrl: "https://img.36krcdn.com/20190515/v2_1557897790237_img_png",
        coverHeight: 1080,
        coverWidth: 1920,
        hasCover: 1,
        hasTitle: 0,
        operationId: 81604378625,
        skipTypeFormat: "内外链",
        // title: '人造肉公司都上市了，但离端上老百姓的餐桌还有点难',
        syncOperationList: Math.random() > .5 ? [
          {operationId: 321, operationName: 'banner', hasTitle: 1,hasCover: 1,coverWidth: 1920,coverHeight: 1080, title: '23', coverUrl: 'https://pic.36krcnd.com/201905/08094859/3aqoslvw6crfijxe!heading', coverPath: '/201905/08094859/3aqoslvw6crfijxe!heading'},
          {operationId: 456, operationName: 'bbbnnner', hasTitle: 1,hasCover: 1,coverWidth: 1280,coverHeight: 720, title: '11', coverUrl:'https://pic.36krcnd.com/201905/08094859/3aqoslvw6crfijxe!heading', coverPath: '/201905/08094859/3aqoslvw6crfijxe!heading'},
        ]: null
        // coverList: [
        //   {operationId: 123, ossUrl:'https://pic.36krcnd.com/201905/08094859/3aqoslvw6crfijxe!heading', path: 'img.png'},
        //   {operationId: 321, ossUrl: 'https://pic.36krcnd.com/201905/04232139/woyj4ldzx7fwvsck!heading', path: 'img.png'},
        //   {operationId: 456, ossUrl: 'https://img.36krcdn.com/20190509/v2_1557376032879_img_jpg', path: 'img.png'}
        // ]
      }
    }]
  })
  mock.onAny(api.operation.modInit).reply(200, {
    code: 0,
    data: {
      coverHeight: 1200,
      coverPath: "/20190515/v2_1557897790237_img_png",
      coverUrl: "https://img.36krcdn.com/20190515/v2_1557897790237_img_png",
      coverWidth: 900,
      endTime: "2019-05-15 10:52:32",
      hasCover: 1,
      hasTitle: 1,
      title: '1321',
      operationName: "首页-活动弹窗（正中）",
      platformName: "App",
      remark: "dddd",
      skipLink: "http://www.baiu.comeee",
      startTime: "2019-05-15 10:52:32",
      widgetType: "内外链",
      syncOperationList: [
          {operationId: 321, operationName: 'banner', hasTitle: 1,hasCover: 1,coverWidth: 1920,coverHeight: 1080, title: '23', coverUrl: 'https://pic.36krcnd.com/201905/08094859/3aqoslvw6crfijxe!heading'},
          {operationId: 456, operationName: 'bbbnnner', hasTitle: 1,hasCover: 1,coverWidth: 1280,coverHeight: 720, title: '11', coverUrl:'https://pic.36krcnd.com/201905/08094859/3aqoslvw6crfijxe!heading'},
        ]
    }
  })
  let a = 1
  mock.onPost(api.operation.list).reply(() => {
    const getList = (idx) => {
       return {
         "id":idx,
         "status":1,
         "statusFormat":"已发布",
         "startTime":"2019-05-14 07:44:01",
         "endTime":"2019-05-14 07:44:01",
         coverUrl: "https://img.36krcdn.com/20190515/v2_1557918235547_img_png",
         "coverPath":"",
         "remark":a
        }
    }
    let list = []
    for (var i = 0; i < 10; i++) {
      list.push(getList(i))
    }
    const aaa = {
    
      "code":0,
      "data":{
        "recomMaterialList": list,//[
          // {coverPath: "/20190515/v2_1557918235547_img_png",
          // coverUrl: "https://img.36krcdn.com/20190515/v2_1557918235547_img_png",
          // endTime: "2019-05-16 07:13:55",
          // id: 20,
          // remark: "",
          // startTime: "2019-05-15 07:13:55",
          // status: 1,
          // statusFormat: "已发布",
          // // title: "快讯051503",
          // updateTime: "2019-05-15 19:12:27",
          // updateUserId: 131,
          // updateUserName: "15612983819"}
          // {"id":4,"status":1,"statusFormat":"已发布","startTime":"2019-05-14 07:44:01","endTime":"2019-05-14 07:44:01","coverPath":"","remark":""},
          // {"id":3,"status":-1,"statusFormat":"已下线","updateTime":"2019-05-14 19:34:22","startTime":"2019-05-14 07:03:03","endTime":"2019-05-14 07:03:03","remark":""},
          // {"id":2,"status":-1,"statusFormat":"已下线","updateTime":"2019-05-14 18:53:19","startTime":"2019-05-14 07:02:44","endTime":"2019-05-14 07:02:44","remark":""},
          // {"id":1,"status":-1,"statusFormat":"已下线","updateTime":"2019-05-14 18:52:52","startTime":"2019-05-14 05:43:50","endTime":"2019-05-14 05:43:50","coverPath":"","remark":""}
        //],
        "statusList":[{"id":-1,"name":"已下线"},{"id":1,"name":"已发布"},{"id":2,"name":"待发布"}],
        "page":{"prePage":a-1,"nextPage":a+1,"pageNo":a,"pageSize":10,"totalPage":40,"totalCount":400},
      }
    }
    // console.log('wwwwwwww', a)
    // if (a >= 2 && a< 6) {
    //   aaa.data.recomMaterialList[0].title = '2222'
    //   delete aaa.data.recomMaterialList[0].coverUrl
    // } else {

    //   aaa.data.recomMaterialList[0].coverUrl = "https://img.36krcdn.com/20190515/v2_1557918235547_img_png"
    // }
    a++
    console.log('aaa',aaa)
    return [200, aaa]
  })
})
http.setMockRule(false, mock => {
  mock.onPost(api.operation.cascader).reply(200, {
    code: 0,
    data: {
      latestNodeId: 12,
      nodeList: [{
        name: 'APP-推荐',
        children: [
          {
            name: '推荐主题',
            id: 1,
          },
          {
            name: '信息流No.6afw是而非违法违法驱蚊器曲儿关切',
            id: 2,
          }
        ]
      }, {
        name: 'APP-出行',
        children: [
          {
            name: '信息流No.11',
            id: 12,
          },
          {
            name: '浮窗(右下)',
            id: 13
          }
        ]
      }],
    }
  })
  mock.onPost(api.operation.online).reply(() => {
    return [200, {
      code: 1,
      msg: '当前{跳转内容}为下线状态，请检查后重试'
    }]
  })
  mock.onPost(api.operation.offline).reply(() => {
    return [200, {
      code: 0,
      data: {}
    }]
  })
  mock.onPost(api.operation.list).reply(() => { 
    const materialList = [{
      id: 1,
      status: '待上线',
      coverUrl: 'https://pic.36krcnd.com/201905/08131237/khnc2fdsztdxwkdk!heading',
      title: '标题xxx',
      publishTime: moment().format("YYYY-MM-DD hh:mm:ss"),
      offlineTime: '2018/12/22 12:00:11',
      updateTime: '2018/12/22 12:00:11',
      remark: '123',
      updateUserName: '赵晔',
      hasPublished: 0,
      hasWaitToPub: 1,
    },{
      id: 2,
      status: '已上线',
      coverUrl: 'https://pic.36krcnd.com/201905/08110325/z5lq8qlwtzvvj7sc!heading',
      title: '标题eee',
      publishTime: moment().format("YYYY-MM-DD hh:mm:ss"),
      offlineTime: '2019/12/22 08:01:11',
      updateTime: '2019/12/22 08:01:11',
      remark: '312',
      updateUserName: '赵晔',
      hasPublished: 1,
      hasWaitToPub: 0,
    },{
      id: 3,
      status: '已上线',
      coverUrl: 'https://pic.36krcnd.com/201905/08102515/mo6otnc2gm747ypg!heading',
      title: '标题eee',
      publishTime: moment().format("YYYY-MM-DD hh:mm:ss"),
      offlineTime: '2019/12/22 08:01:11',
      updateTime: '2019/12/22 08:01:11',
      remark: '312',
      updateUserName: '赵晔',
      hasPublished: 1,
      hasWaitToPub: 0,
    },{
      id: 3,
      status: '已下线',
      coverUrl: 'https://pic.36krcnd.com/201905/08095330/uzgwqvh9iuro1e38!heading',
      title: '标题eee',
      publishTime: moment().format("YYYY-MM-DD hh:mm:ss"),
      offlineTime: '2019/12/22 08:01:11',
      updateTime: '2019/12/22 08:01:11',
      remark: '312',
      updateUserName: '赵晔',
      hasPublished: 0,
      hasWaitToPub: 0,
    }]
    const r = Math.random()
    if (r > .7) {
      materialList.pop()
    }
    if (r < .3) {
      materialList.pop()
      materialList.pop()
    }
    return[200, {
      code: 0,
      data: {
        materialList,        
        statusList: [{id: 1, name: '已上线'},{id: 2, name: '已下线'}],
      }
    }]
  })
  mock.onPost(api.operation.checkLink).reply(() => {
    return [200, {
      code: 0,
      data: {
        originalCoverUrl: 'https://pic.36krcnd.com/201905/08094859/3aqoslvw6crfijxe!heading',
        widgetType: '文章、资讯',
        title: '人造肉公司都上市了，但离端上老百姓的餐桌还有点难',
        coverList: [
          {operationId: 123, ossUrl:'https://pic.36krcnd.com/201905/08094859/3aqoslvw6crfijxe!heading', path: 'img.png'},
          {operationId: 321, ossUrl: 'https://pic.36krcnd.com/201905/04232139/woyj4ldzx7fwvsck!heading', path: 'img.png'},
          {operationId: 456, ossUrl: 'https://img.36krcdn.com/20190509/v2_1557376032879_img_jpg', path: 'img.png'}
        ]
      }
    }]
  })
  mock.onPost(api.operation.orderList).reply(() => { return [200, {
      code: 0,
      data: {
        materialList: [
          {id: 1, status: '待发布', title: '不不不', updateTime: moment().format("YYYY-MM-DD hh:mm:ss"), 操作人: '发发发去去去'},
          {id: 2, status: '已上线', title: '不不不', updateTime: '发发发', 操作人: '发发发去去去'},
          {id: 3, status: '已上线', title: '不不不', updateTime: '发发发', 操作人: '发发发去去去'},
          {id: 4, status: '已上线', title: '不不不', updateTime: '发发发', 操作人: '发发发去去去'},
        ]
      }
    }]
  })
  mock.onPost(api.operation.addInit).reply(() => {
    return [200, {
      code: 0,
      data: {
        platformName      : 'APP',
        operationName      : 'banner',
        operationId        : 123,
        hasTitle          : 1,
        hasCover          : 1,
        coverWidth        : 1360,
        coverHeight       : 768,
        syncOperationList  : [
          {operationId: 321, operationName: 'banner', hasTitle: 1,hasCover: 1,coverWidth: 1920,coverHeight: 1080},
          {operationId: 456, operationName: 'bbbnnner', hasTitle: 1,hasCover: 1,coverWidth: 1280,coverHeight: 720},
        ]
      }
    }]
  })
  mock.onPost(api.operation.modInit).reply(() => {
    return [200, {
      code: 0,
      data: {
        platformName      : 'APP',
        operationName      : 'banner',
        operationId        : 123,
        hasTitle          : 1,
        hasCover          : 1,
        coverWidth        : 1360,
        coverHeight       : 768,
        syncOperationList  : [
          {
            operationId: 321, operationName: 'banner', hasTitle: 1,hasCover: 1,coverWidth: 1920,coverHeight: 1080,
            hasChecked: 0, title: '标题xxx', cover: {ossUrl: 'https://pic.36krcnd.com/201905/04232139/woyj4ldzx7fwvsck!heading', path: 'img.png'},
          },
          {
            operationId: 456, operationName: 'bbbnnner', hasTitle: 1,hasCover: 1,coverWidth: 1280,coverHeight: 720,
            hasChecked: 1, title: '标题yyy', cover: {ossUrl: 'https://img.36krcdn.com/20190509/v2_1557376032879_img_jpg', path: 'img.png'},
          },
        ],
        cover: {ossUrl: 'https://pic.36krcnd.com/201905/08094859/3aqoslvw6crfijxe!heading', path: 'img.png'},
        title: '标题',
        skipLink: 'https://36kr.com',
        originalCoverUrl: 'https://pic.36krcnd.com/201905/08094859/3aqoslvw6crfijxe!heading',
        widgetType: '支持文章、快讯',
        startTime: moment().format("YYYY-MM-DD hh:mm:ss"),
        endTime: moment().format("YYYY-MM-DD hh:mm:ss"),
        remark: '备注'
      }
    }]
  })
  mock.onPost(api.operation.moveDown).reply(200, {
    code: 0,
    data: {}
  })
  mock.onPost(api.operation.moveUp).reply(200, {
    code: 0,
    data: {}
  })
})